import React, { useState, useCallback, useEffect } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { Button, Form, Spinner } from "react-bootstrap";
import { updateClientLatLong, getAllClientsByLogisId } from "../Services/masterService";
import Modal from "../AlertModal/Modal";
import Select from "react-select";


const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "12px",
  marginTop: "15px",
};

const defaultCenter = { lat: 22.5744, lng: 88.3629 };

const LogisticsLocation = () => {
  const [selectedClient, setSelectedClient] = useState("");
  const [clients, setClients] = useState([]);
  const [currentPosition, setCurrentPosition] = useState(defaultCenter);
  const [loadingClients, setLoadingClients] = useState(false);
  const [loadingLocation, setLoadingLocation] = useState(false);

  // ✅ Load Google Maps API
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAeQzuOcT3aIg5Ql2__hJ2bDli20jCA-Bo", // Replace with your API key
  });

  // Fetch clients once
  useEffect(() => {
    fetchClients();
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({});

  const showSuccess = (msg) => {
    setModalConfig({
      title: "Success!",
      message: msg,
      type: "success",
    });
    setIsModalOpen(true);
  };

  const showError = (titleMsg, message) => {
    setModalConfig({
      title: titleMsg,
      message: message,
      type: "error",
    });
    setIsModalOpen(true);
  };

  const fetchClients = async () => {
    const storedUser = localStorage.getItem('user');
    const userInfo = JSON.parse(storedUser)
    try {
      setLoadingClients(true);
      const response = await getAllClientsByLogisId(userInfo.id);
      if (response.status === 1 && Array.isArray(response.data)) {
        setClients(response.data.filter(item => item.status === "ACTIVE"));
      } else {
        setClients([]);
      }
    } catch (error) {
      console.log("Error fetching clients:", error);
      setClients([]);
    } finally {
      setLoadingClients(false);
    }
  };

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      // alert("Geolocation is not supported by this browser.");
      showError("Oops!", "Geolocation is not supported by this browser.")
      return;
    }

    setLoadingLocation(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCurrentPosition({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setLoadingLocation(false);
      },
      (error) => {
        // alert("Unable to fetch your location: " + error.message);
        showError("Oops!", "Unable to fetch your location: " + error.message)
        setLoadingLocation(false);
      }
    );
  };

  const onMarkerDragEnd = useCallback((e) => {
    setCurrentPosition({ lat: e.latLng.lat(), lng: e.latLng.lng() });
  }, []);

  const handleSave = async () => {
    if (!selectedClient) {
      showError("Sorry!", "Client is required!")
      return;
    }

    const request = {
      clientCode: selectedClient,
      latitude: currentPosition.lat,
      longitude: currentPosition.lng,
    };

    try {
      const response = await updateClientLatLong(request);
      if (response.status === 1) {
        showSuccess("Location saved successfully!")
      } else {
        showError("Sorry!", "Failed to save location!")
      }
    } catch (error) {
      console.error(error);
      showError("Sorry!", "Internal server error " + error)
    }
  };

  if (loadError) return <p className="text-center text-danger">Map failed to load</p>;

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="main-wrap">
        <div className="container">
          <div className="title">
            <h4>Client Location Update</h4>
          </div>

          {/* Client Dropdown */}
          {/* <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Select Client</Form.Label>
            {loadingClients ? (
              <div className="text-center">
                <Spinner animation="border" variant="success" />
              </div>
            ) : (
              <Form.Select value={selectedClient} onChange={(e) => setSelectedClient(e.target.value)}>
                <option value="">-- Select Client --</option>
                {clients.map((client) => (
                  <option key={client.id} value={client.clientCode}>
                    {client.clientName}
                  </option>
                ))}
              </Form.Select>
            )}
          </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Select Client</Form.Label>

            {loadingClients ? (
              <div className="text-center">
                <Spinner animation="border" variant="success" />
              </div>
            ) : (
              <Select
                id="clientSelect"
                value={
                  clients
                    .map((client) => ({
                      value: client.clientCode,
                      label: client.clientName,
                    }))
                    .find((option) => option.value === selectedClient) || null
                }
                onChange={(selectedOption) =>
                  setSelectedClient(selectedOption?.value || "")
                }
                options={clients.map((client) => ({
                  value: client.clientCode,
                  label: client.clientName,
                }))}
                placeholder="-- Select Client --"
                isSearchable
                classNamePrefix="react-select"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#d1d5db",
                    borderRadius: "0.375rem",
                    boxShadow: "none",
                    "&:hover": { borderColor: "#16a34a" },
                  }),
                }}
              />
            )}
          </Form.Group>

          {/* Get Location Button */}
          <Button
            onClick={handleGetLocation}
            className="w-100 mb-3 cmn-button"
            style={{
              backgroundColor: "#6c757d", // medium grey
              borderColor: "#6c757d",
              color: "white",
            }}
          >
            {loadingLocation ? "Getting Location..." : "📍 Get My Current Location"}
          </Button>



          {/* Google Map */}
          {isLoaded ? (
            <GoogleMap mapContainerStyle={containerStyle} center={currentPosition} zoom={15}>
              <Marker position={currentPosition} draggable onDragEnd={onMarkerDragEnd} />
            </GoogleMap>
          ) : (
            <p className="text-center text-muted">Loading map...</p>
          )}

          {/* Save Button */}
          <Button variant="outline-success" className="mt-3 w-100 cmn-button" onClick={handleSave}>
            Save Location
          </Button>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={modalConfig.title}
        message={modalConfig.message}
        type={modalConfig.type}
      />
    </div>
  );
};

export default LogisticsLocation;
